<div class="app-main-header">
  <div class="logo-container">
    <a
      (click)="scrollTop()"
      [routerLink]="isAffiliatePage || isAffiliateFlow ? '/affiliate' : ''"
      class="p-0 m-0"
    >
      <img
        alt="{{ 'lbl_img_alt_logo' | translate }}"
        class="header-logo"
        ngSrc="assets/images/logo/pitch59-logo-white.svg"
        width="150"
        height="54"
      />
    </a>

    @if(isLandingPage)
    {
      <p-select [options]="cardTypeOptions" 
      (onChange)="onLandingPageChange($event)"
       [(ngModel)]="businessType" 
       optionLabel="label"
        optionValue="value" 
        [panelStyle]="cardTypePanelStyle"
        class="w-full ml-4 text-[#fff] bg-transparent" />
      <!-- <p-select [options]="cardTypeOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="businessType"
                (onChange)="onLandingPageChange($event)"
                appendTo="body"
                class="type-dropdown"
                panelStyleClass="type-dropdown-panel"
                [panelStyle]="cardTypePanelStyle">
        <ng-template let-type pTemplate="item">
          <div class="flex align-items-center gap-2 m-auto" style="padding: 10px">
            <p class="m-0">{{ type.label }}</p>
          </div>
        </ng-template>
      </p-select> -->
  }
  </div>

  @if(isAffiliateFlow && signedIn())
  {
    <div class="profile-container">
      <a class="logout flex text-white text-sm align-items-center"
        (click)="doSignOut()">
        Log Out
       <img src="assets/images/logout.svg" />
      </a>
    </div>
  }

  <div class="profile-container">
    <div
      class="resources-dropdown-container"
      *ngIf="!isMobile && !isAffiliatePage"
    >
      <app-resource-dropdown
        [items]="resourceMenuItems"
        buttonText="Resources"
      ></app-resource-dropdown>
    </div>
    <div
      *ngIf="!isAffiliatePage"
      #rla="routerLinkActive"
      (click)="refreshSearch()"
      [ngClass]="{ active: rla.isActive }"
      class="grid align-items-center mt-0 search-btn"
      routerLink="/search"
      routerLinkActive="active"
    >
      <div *ngIf="searchPage && !isDesktop" class="search-icon"></div>
      <span *ngIf="isDesktop" class="search-text" translate>
        label_Search
      </span>
    </div>
    <span
      *ngIf="!isAffiliatePage"
      #rla="routerLinkActive"
      [routerLink]="bannerConfig?.createBtnLink"
      class="pricing-btn"
      routerLinkActive="active"
      translate
    >
      label_pricing
    </span>
    <button
      *ngIf="!isMobile && !isHasPitchCard"
      class="button-simple basic m-auto"
      (click)="
        isAffiliatePage ? navigateToAffiliateOnboarding() : navigateToPricing()
      "
    >
      Create PitchCard
    </button>
    <div class="ml-2" *ngIf="!isMobile && isHasPitchCard"></div>
    <button
      *ngIf="!isMobile && isHasPitchCard"
      class="button-simple basic m-auto"
      (click)="navigateToMyPitchCards()"
    >
      My PitchCards
    </button>
  </div>

  <div class="profile-container" *ngIf="!isAffiliateFlow">
    <span
      #rla="routerLinkActive"
      (click)="openAuth('SIGN_IN')"
      *ngIf="!signedIn()"
      [ngClass]="{ active: rla.isActive }"
      class="sign-in-up-btn"
      routerLinkActive="active"
      translate>
      label_sign_in
    </span>
    <span
      #rla="routerLinkActive"
      (click)="openAuth('SIGN_UP')"
      *ngIf="!signedIn()"
      [ngClass]="{ active: rla.isActive }"
      class="sign-in-up-btn"
      routerLinkActive="active">
      {{ 'label_sign_up' | translate }}
    </span>
    <div
      #guestMenuContainer
      class="custom-menu-container"
      *ngIf="!signedIn()">
      <div (click)="toggleGuestMenu($event)"
        class="burger-btn"
      >
      <div class="item"></div>
      <div class="item"></div>
      <div class="item"></div>
      </div>

      <!-- Guest Menu Content -->
       @if(isGuestMenuVisible)
       {
        <app-user-profile-menu [isVisible]="isGuestMenuVisible"
                              [menuItems]="unauthorizedItems"
                              [showHeader]="false"
                              (itemClicked)="onMenuItemClick($event)">
      </app-user-profile-menu>
       }
    </div>

    <div #profileMenuContainer
      class="custom-menu-container">
    
      @if (signedIn())
      {
        <div (click)="toggleProfileMenu($event)"
              class="flex align-content-center justify-content-center cursor-pointer profile-menu-container">
          @if(!isMobile)
          {
            <div class="greeting-sign">
              <span>Welcome</span>
              <span>{{ userFirstName() || 'User' }}</span>
            </div>
          }
          <div class="profile-photo-container">
            <img [ngClass]="{'no-padding': profilePictureThumbnailUrl() !== defaultProfileUrl}"
                  [src]="profilePictureThumbnailUrl()"
                  alt="profile_photo"
                  class="profile-photo" />
          </div>
        </div>
      }
  
      <!-- Profile Menu Content -->
       @if(isProfileMenuVisible)
       {
        <app-user-profile-menu [isVisible]="isProfileMenuVisible"
                                [menuItems]="items"
                                (itemClicked)="onMenuItemClick($event)">
      </app-user-profile-menu>
       }
    </div>

  </div>
</div>
<p-message
  *ngIf="isWarningBannerVisible"
  severity="warn"
  icon="pi pi-exclamation-triangle"
  [closable]="true"
  (onClose)="dismissWarningBanner()"
  styleClass="warning-banner"
>
  <div class="warning-banner-content">
    <span class="warning-banner-text">Please update your payment details in order to continue uninterrupted access to your features</span>
    <p-button
      label="Manage Subscription"
      severity="warn"
      [outlined]="true"
      size="small"
      (onClick)="navigateToMySubscriptions()"
    />
  </div>
</p-message>
@if(isContactDialogActive)
{
  <p-dialog
    [closable]="true"
    (onHide)="resetContactForm()"
    [(visible)]="isContactDialogActive"
    [dismissableMask]="true"
    [draggable]="false"
    [modal]="true"
    [baseZIndex]="99999"
    [style]="{ zIndex: 99999 }"
    styleClass="contact-dialog bg-primary-linear"
    appendTo="body"
  >
    <form [formGroup]="contactForm" class="contact-form" (submit)="sendHelpRequest()">
      <div class="flex flex-column mb-3">
        <h2 class="mb-0">{{ contactFormType === 0 ? 'Contact Sales' : 'Contact Support' }}</h2>
        <span class="contact-form-subheader mb-2 mt-2">+1 (832) 412-4070</span>
        <span class="contact-form-subheader">
          {{ contactFormType === 0 ? 'sales@pitch59.com' : 'help@pitch59.com' }}</span>
      </div>
      <div class="double-form-row">
        <div class="form-row-input">
          <span>
            <label for="firstName">First Name*</label>
            <input
              id="firstName"
              formControlName="firstName"
              placeholder="First Name"
              appNoLeadingSpace
              class="bordered-input"
              pInputText
              size="30"
              type="text"
            />
          </span>
          <div
            *ngIf="contactForm.controls.firstName.dirty && contactForm.controls.firstName.errors?.required"
            class="error-sign"
          >
            First Name is required
          </div>
        </div>
        <div class="form-row-input">
          <span>
            <label for="lastName">Last Name*</label>
            <input
              id="lastName"
              formControlName="lastName"
              placeholder="Last Name"
              appNoLeadingSpace
              class="bordered-input"
              pInputText
              size="30"
              type="text"
            />
          </span>
          <div
            *ngIf="contactForm.controls.lastName.dirty && contactForm.controls.lastName.errors?.required"
            class="error-sign"
          >
            Last Name is required
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-row-input">
          <span>
            <label for="email">Email Address*</label>
            <input
              id="email"
              formControlName="email"
              placeholder="example@gmail.com"
              appNoLeadingSpace
              autocomplete="email"
              class="bordered-input"
              pInputText
              type="email"
              size="30"
            />
          </span>
          <div
            *ngIf="contactForm.controls.email.dirty && contactForm.controls.email.errors?.required"
            class="error-sign"
          >
            Email is required
          </div>
          <div
            *ngIf="contactForm.controls.email.dirty && contactForm.controls.email.errors?.pattern"
            class="error-sign"
          >
            Invalid email format
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-row-input">
          <span>
            <label for="subject">Subject of Message*</label>
            <input
              id="subject"
              formControlName="subject"
              placeholder="Message Subject"
              appNoLeadingSpace
              class="bordered-input"
              pInputText
              size="30"
              type="text"
            />
          </span>
          @if(contactForm.controls.subject.dirty && contactForm.controls.subject.errors?.required)
          {
            <div class="error-sign">
              Subject is required
            </div>
          }
        </div>
      </div>
      <div class="form-row">
        <div class="form-row-input">
          <span class="mt-4">
            <app-country-input label="{{ 'label_mobile_number' | translate }}*"
                                [required]="true"
                                placeholder="{{ 'label_mobile_number' | translate }}"
                                formControlName="phoneNumber"
                                [containerStyleClass]="'bordered-container-gray'"
                                [inputStyleClass]="'borderless'"
                                [flagDropdownStyle]="'borderless'"
                                [floatLabel]="false"
            ></app-country-input>
          </span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-row-input">
          <textarea
            id="message"
            formControlName="message"
            placeholder="Message content"
            class="bordered-input"
            pInputTextarea
            rows="5"
          ></textarea>
        </div>
      </div>
      <div class="form-row mt-3">
        <button
          [disabled]="!contactForm.valid"
          class="button-simple basic contact-form-btn mt-2"
          type="submit"
        >
          Submit
        </button>
      </div>
    </form>
  </p-dialog>
}
<p-toast class="w-half"/>
